import React, { useEffect, useState } from 'react'
import logo from '../../assets/images/logo.png'
import avtar from '../../assets/images/user/avatar-1.jpg'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useProfile } from '../Context/ProfileContext'
import { imgUrl } from '../Services/api'


const Sidebar = ({ isHidden }) => {
    const location = useLocation();
    const pathname = location.pathname;
    const navigate = useNavigate();
    const { profile, fetchProfile } = useProfile();
    
    // Derive activeMenu from pathname
    const getActiveMenuFromPath = () => {
        if (pathname.startsWith('/users')) return 'users';
        if (pathname.startsWith('/manager')) return 'manager';
        if (pathname.startsWith('/routes')) return 'routes';
        if (pathname.startsWith('/contacttypes')) return 'contacttypes';
        if (pathname.startsWith('/complaint/complaint-list')) return 'complaint'; 
        if (pathname.startsWith('/customer/customer-list')) return 'customer'; 
         if (pathname.startsWith('/company')) return 'company'; 
        // if (pathname.startsWith('/contacts')) return 'contacts';
        if (pathname.startsWith('/cms')) return 'cms';
        if (pathname === '/' || pathname === '/dashboard') return '/';
        return null;
    };

    const [openMenu, setOpenMenu] = useState(getActiveMenuFromPath());
    const [activeMenu, setActiveMenu] = useState(getActiveMenuFromPath());


    // Reset open menu when path changes (optional)
    useEffect(() => {
        const currentMenu = getActiveMenuFromPath();
        setActiveMenu(currentMenu);
        setOpenMenu(currentMenu);
    }, [pathname]);

    const handleMenuToggle = (menuKey) => {
        setOpenMenu(prev => (prev === menuKey ? null : menuKey));
    };

    const handleLogout = async (e) => {
        e.preventDefault();
        localStorage.removeItem("token");
        localStorage.clear();
        navigate('/login');
    };
    useEffect(() => {
        fetchProfile();
    }, []);
    return (
        <nav className={`pc-sidebar ${isHidden ? 'pc-sidebar-hide' : ''}`}>
            <div className="navbar-wrapper">
                <div className="m-header d-flex align-items-center justify-content-center my-3">
                    <Link to="/" className="b-brand text-primary">
                        <img src={logo} width={50} height={50} className="img-fluid logo-lg" alt="logo" />
                    </Link>
                </div>
                <div className="navbar-content">
                    <div className="card pc-user-card">
                        <div className="card-body">
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0">
                                    <img src={profile?.profile_image ? `${imgUrl}${profile?.profile_image}` : avtar} alt="user" className="user-avtar wid-45 rounded-circle" />
                                </div>
                                <div className="flex-grow-1 ms-3 me-2">
                                    <h6 className="mb-0">{profile?.username}</h6>
                                    <small>Administrator</small>
                                </div>
                                <a className="btn btn-icon btn-link-secondary avtar" data-bs-toggle="collapse" href="#pc_sidebar_userlink">
                                    <i className="fas fa-sort pc-icon"></i>
                                </a>
                            </div>
                            <div className="collapse pc-user-links" id="pc_sidebar_userlink">
                                <div className="pt-3">
                                    <Link to="/profile">
                                        <i className="fas fa-user" />
                                        <span>My Account</span>
                                    </Link>
                                    <Link to="#" onClick={handleLogout}>
                                        <i className="fas fa-power-off" />
                                        <span>Logout</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ul className="pc-navbar">
                        <li className="pc-item pc-caption">
                            <label>Navigation</label>
                        </li>
                        <li className={`pc-item ${pathname === '/' ? 'active' : ''}`}>
                            <Link to="/" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fas fa-chart-line pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Dashboard</span>
                            </Link>
                        </li>

                        {/* Users */}
                        <li className="pc-item pc-caption">
                            <label>Users</label>
                        </li>
                       


                          <li className={`pc-item pc-hasmenu ${openMenu === 'manager' ? 'pc-trigger' : ''} ${activeMenu === 'manager' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('manager')}>
                                <span className="pc-micon">
                                    <i className="fas fa-users pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Manager Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'manager' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/manager/add-manager' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/manager/add-manager">Add Manager</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/manager/manager-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/manager/manager-list">Manager List</Link>
                                </li>
                            </ul>
                        </li>


                        <li className={`pc-item pc-hasmenu ${openMenu === 'users' ? 'pc-trigger' : ''} ${activeMenu === 'users' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('users')}>
                                <span className="pc-micon">
                                    <i className="fas fa-users pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Salesmen Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'users' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/users/add-user' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/users/add-user">Add Salesmen</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/users/user-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/users/user-list">Salesmen List</Link>
                                </li>
                            </ul>
                        </li>
                        


                        <li className={`pc-item pc-hasmenu ${openMenu === 'routes' ? 'pc-trigger' : ''} ${activeMenu === 'routes' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('routes')}>
                                <span className="pc-micon">
                                    <i className="fas fa-route pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Route Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'routes' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/routes/add-route' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/routes/add-route">Add Route</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/routes/route-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/routes/route-list">Route List</Link>
                                </li>
                            </ul>
                        </li>
                        


                         


                        <li className={`pc-item ${pathname.startsWith('/customer') ? 'active' : ''}`}>
                            <Link to="/customer/customer-list" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fas fa-users pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Customer</span>
                            </Link>
                        </li>


                        {profile?.id == '4' && (
                            <li className={`pc-item ${pathname.startsWith('/admin') ? 'active' : ''}`}>
                                <Link to="/admin/admin-list" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fas fa-list pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Admin</span>
                                </Link>
                            </li>
                            )}



                        <li className={`pc-item ${pathname.startsWith('/complaint') ? 'active' : ''}`}>
                            <Link to="/complaint/complaint-list" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fas fa-list pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Complaints</span>
                            </Link>
                        </li>


                        <li className={`pc-item ${pathname.startsWith('/beat') ? 'active' : ''}`}>
                            <Link to="/beat/list" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fas fa-list pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Beat Plan</span>
                            </Link>
                        </li> 


                        <li className={`pc-item ${pathname.startsWith('/call-log') ? 'active' : ''}`}>
                            <Link to="/call-log/list" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fas fa-list pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Call log</span>
                            </Link>
                        </li>


                        <li className={`pc-item ${pathname.startsWith('/visit-log') ? 'active' : ''}`}>
                            <Link to="/visit-log/list" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fas fa-list pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Visit log</span>
                            </Link>
                        </li>





                        {/* Route */}
                        {/* <li className="pc-item pc-caption">
                            <label>Route Management</label>
                        </li>
                        <li className={`pc-item pc-hasmenu ${openMenu === 'routes' ? 'pc-trigger' : ''} ${activeMenu === 'routes' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('routes')}>
                                <span className="pc-micon">
                                    <i className="fas fa-route pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Route Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'routes' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/routes/add-route' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/routes/add-route">Add Route</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/routes/route-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/routes/route-list">Route List</Link>
                                </li>
                            </ul>
                        </li> */}


                        {/* Contact Type */}
                        <li className="pc-item pc-caption">
                            <label>Contact Type</label>
                        </li>
                        <li className={`pc-item pc-hasmenu ${openMenu === 'contacttypes' ? 'pc-trigger' : ''} ${activeMenu === 'contacttypes' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('contacttypes')}>
                                <span className="pc-micon">
                                    <i className="fas fa-phone pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Customer Type</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'contacttypes' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/contacttypes/add-contacttype' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/contacttypes/add-contacttype">Add Type</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/contacttypes/contacttype-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/contacttypes/contacttype-list">Type List</Link>
                                </li>
                            </ul>
                        </li>


                       {profile?.id == '4' && (
                                <>
                                    <li className="pc-item pc-caption">
                                    <label>Company</label>
                                    </li>

                                    <li className={`pc-item pc-hasmenu ${openMenu === 'company' ? 'pc-trigger' : ''} ${activeMenu === 'company' ? 'active' : ''}`}>
                                    <Link to="#" className="pc-link" onClick={() => handleMenuToggle('company')}>
                                        <span className="pc-micon">
                                        <i className="fas fa-list pc-icon"></i>
                                        </span>
                                        <span className="pc-mtext">Company</span>
                                        <span className="pc-arrow">
                                        <i className="fas fa-chevron-right"></i>
                                        </span>
                                    </Link>

                                    <ul className={`pc-submenu ${openMenu === 'company' ? 'd-block' : ''}`}>
                                        <li className={`pc-item ${pathname === '/company/add-company' ? 'active' : ''}`}>
                                        <Link className="pc-link" to="/company/add-company">
                                            Add Company
                                        </Link>
                                        </li>

                                        <li className={`pc-item ${pathname === '/company/company-list' ? 'active' : ''}`}>
                                        <Link className="pc-link" to="/company/company-list">
                                            Company List
                                        </Link>
                                        </li>
                                    </ul>
                                    </li>
                                </>
                                )}



                        {/* CMS */}
                        <li className="pc-item pc-caption">
                            <label>CMS Management</label>
                        </li>
                        <li className={`pc-item pc-hasmenu ${openMenu === 'cms' ? 'pc-trigger' : ''} ${activeMenu === 'cms' ? 'active' : ''}`}>
                            <Link to="#" className="pc-link" onClick={() => handleMenuToggle('cms')}>
                                <span className="pc-micon">
                                    <i className="fas fa-house pc-icon"></i>
                                </span>
                                <span className="pc-mtext">CMS Management</span>
                                <span className="pc-arrow"><i className="fas fa-chevron-right"></i></span>
                            </Link>
                            <ul className={`pc-submenu ${openMenu === 'cms' ? 'd-block' : ''}`}>
                                <li className={`pc-item ${pathname === '/cms/add-cms' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/cms/add-cms">Add CMs</Link>
                                </li>
                                <li className={`pc-item ${pathname === '/cms/cms-list' ? 'active' : ''}`}>
                                    <Link className="pc-link" to="/cms/cms-list">CMS List</Link>
                                </li>
                            </ul>
                        </li>

                        {/* Help & Support */}
                        {/* <li className="pc-item pc-caption">
                            <label>Help & Support</label>
                        </li>
                        <li className={`pc-item ${pathname === '/contacts/contact-list' ? 'active' : ''}`}>
                            <Link to="/contacts/contact-list" className="pc-link">
                                <span className="pc-micon">
                                    <i className="fas fa-hands-helping pc-icon"></i>
                                </span>
                                <span className="pc-mtext">Help & Support</span>
                            </Link>
                        </li> */}
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default Sidebar
